import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import WalletFilters from '../../commons/WalletFilters/WalletFilters'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import WalletList from '../../commons/WalletList/WalletList'
import routes from '../../../config/routes'
import {
  walletApplyFilters,
  walletClearAllFilter
} from '../../../reducks/resources/wallet/actions'

const WalletSearchContainer = (props) => {
  const {
    match: {
      params: { search }
    }
  } = props

  const breadcrumbs = useMemo(
    () => [
      {
        id: 1,
        title: 'Carteira',
        path: routes.wallet.path
      },
      {
        id: 2,
        title: 'Busca'
      }
    ],
    []
  )

  const dispatch = useDispatch()
  const { wallets } = useSelector((store) => store.walletReducer)

  useEffect(() => {
    if (search) {
      dispatch(walletApplyFilters({ search, page: 1, perPage: 23 }))
    }
  }, [search, dispatch])

  useEffect(() => {
    return () => dispatch(walletClearAllFilter())
  }, [dispatch])

  return (
    <DefaultLayout>
      <Flex>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          bold
          value={`Resultado da busca: "${search}”`}
        />
      </Flex>
      <Breadcrumb items={breadcrumbs} />

      <WalletFilters params={{ search }} />

      <WalletList wallets={wallets} />
    </DefaultLayout>
  )
}

WalletSearchContainer.defaultProps = {
  match: {
    params: {
      search: null
    }
  }
}

WalletSearchContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      search: PropTypes.string
    })
  })
}

export default WalletSearchContainer
